import ProductCustomBannerMessage, { ProductCustomBannerMessageProps } from './product-custom-banner-message'
export default ProductCustomBannerMessage
export { ProductCustomBannerMessage }
export type { ProductCustomBannerMessageProps }
